import React from "react";
import { Chip } from "./Chip";

/**
 * Approval-inbox row. Every consequential write ends up here per V3 §3.
 * @param {Object} props
 * @param {string} props.reference
 * @param {string} props.title
 * @param {string} props.amount
 * @param {string} [props.requestedBy]
 * @param {string} [props.step]
 * @param {string} [props.expiresIn]
 * @param {"pending"|"approved"|"rejected"|"expired"} [props.status="pending"]
 */
export function ApprovalInboxRow({
  reference, title, amount, requestedBy, step, expiresIn, status = "pending",
}) {
  return (
    <div className="ds-approval-row">
      <div>
        <div className="ds-approval-ref">
          {reference}{requestedBy ? ` · Requested by ${requestedBy}` : ""}
        </div>
        <div className="ds-approval-title">{title}</div>
        {(step || expiresIn) && (
          <div className="type-small" style={{ marginTop: 6 }}>
            {step && <>Step · <strong>{step}</strong></>}
            {step && expiresIn ? " · " : ""}
            {expiresIn && <>expires {expiresIn}</>}
          </div>
        )}
      </div>
      <div style={{ textAlign: "right" }}>
        <div className="ds-approval-amount">{amount}</div>
        <div className="ds-chip-row" style={{ justifyContent: "flex-end", marginTop: 6 }}>
          <Chip status={status} />
        </div>
      </div>
    </div>
  );
}
